import { LoadingButton } from "@mui/lab";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { CustomEvent, Map } from "schemas/functions";

import AboutFormLinks from "../AboutForm/Links";
import {
  SocialMediaFields,
  SocialMediaLinks,
  isValidUsername,
  sanitizeInput,
} from "../AboutForm/helpers";

interface SocialMediaLinksFormProps {
  onboardingForm: Map;
  setOnboardingForm: Dispatch<SetStateAction<Map>>;
  handleBack?: () => void;
  handleSkip?: () => void;
  handleNext: () => Promise<void>;
  loading: boolean;
}

const SocialMediaLinksForm = ({
  onboardingForm,
  setOnboardingForm,
  handleNext,
  handleBack,
  handleSkip,
  loading,
}: SocialMediaLinksFormProps) => {
  const [linksValidation, setLinksValidation] = useState<{
    [key in string]: string | undefined;
  }>({});
  const [links, setLinks] = useState<SocialMediaLinks[]>([]);

  const handleSubmit = async (event: CustomEvent) => {
    event.preventDefault();

    if (Object.values(linksValidation).some((v) => v !== undefined)) {
      return;
    }

    for (const key in onboardingForm) {
      if (key in SocialMediaFields && onboardingForm[key]) {
        const input = sanitizeInput(onboardingForm[key]);
        if (input && !isValidUsername(input) && key !== "portfolioUrl") {
          return;
        }
      }
    }

    await handleNext();
  };

  const _handleSkip = () => {
    // remove all invalid social media links after skipping
    const updatedForm = { ...onboardingForm };

    for (const key in updatedForm) {
      if (key in SocialMediaFields && typeof updatedForm[key] === "string") {
        const input = sanitizeInput(updatedForm[key]);
        if (input && !isValidUsername(input)) {
          delete updatedForm[key];
        }
      }
    }

    setOnboardingForm(updatedForm);

    handleSkip?.();
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Typography variant="h3" sx={{ mb: 3, textAlign: "center" }}>
          <Box
            component="i"
            color="secondary.dark"
            sx={{ pr: 2 }}
            className="fa-solid fa-address-card"
          />
          Your Social Links
        </Typography>

        <AboutFormLinks
          onboardingForm={onboardingForm}
          setOnboardingForm={setOnboardingForm}
          setLinksValidation={setLinksValidation}
          links={links}
          setLinks={setLinks}
          validation={linksValidation}
        />

        <Grid container>
          <Grid item xs="auto">
            {handleBack && (
              <Button onClick={handleBack} color="secondary" disableElevation>
                Back
              </Button>
            )}
          </Grid>
          <Grid item xs></Grid>
          {handleSkip && (
            <Grid item xs="auto">
              <Button onClick={_handleSkip} color="secondary" disableElevation>
                Skip
              </Button>
            </Grid>
          )}
          <Grid item xs="auto">
            <LoadingButton
              loading={loading}
              disableElevation
              variant="contained"
              type="submit"
            >
              Next
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default SocialMediaLinksForm;
